import { Dispatch, SetStateAction } from 'react';
import { useSessionStorage as useSessionStorageHook } from 'usehooks-ts';

import { getInitStorageValue } from '@utils/storageUtils';

export const atsSubscriberSessionStorageKey = `ATS_SUBSCRIBER`;

/**
 * Generic hook that extends the `useSessionStorage` hook from `usehooks-ts`
 * @param key Name of the sessionStorage key
 * @param defaultValue Default value if no value is stored in sessionStorage
 * @param transformValue Function to transform result based on sessionStorage value
 */
export const useSessionStorage = <T, K = T>(
  key: string,
  defaultValue?: T,
  transformValue?: (value: T) => K
): [K, Dispatch<SetStateAction<T>>, VoidFunction] => {
  const [value, setValue, _] = useSessionStorageHook<T>(
    key,
    getInitStorageValue(key) ?? defaultValue ?? (undefined as T)
  );

  const removeValue = () => setValue(undefined as unknown as T);

  return [transformValue?.(value) ?? (value as unknown as K), setValue, removeValue];
};
